export default __webpack_public_path__ + "static/media/svg-5.bd1d2140.svg";